import { functions } from "../functions";

export module NisseiAccordionModule {
  export class Service {
    constructor() {
      document.addEventListener('readCompleteAction', () => {
        Service.accordionAction();
      });
    }

    public static accordionAction() {
      const $elements = document.querySelectorAll('.js__AccordionBodyHeader');
      if ($elements) {
        $elements.forEach($element => {
          $element.addEventListener('click', ($event) => {
            const $self = $element;
            const $parent = $self.closest('.js__Accordion');
            if ($parent) {
              const $target = $parent.querySelector<HTMLElement>('.js__AccordionBodyMain');
              $parent.classList.toggle('js__accordion--isActive');
              if ($target) {
                if ($parent.classList.contains('js__accordion--isActive')) {
                  functions.slideDown($target);
                } else {
                  functions.slideUp($target);
                }
              }
            }
          });
        });
      }
    }
  }
}